<template>
  <div>
    <slot name="checkout-button">
      <v-btn text color="primary" @click="checkout(price.id)">
        <div v-if="price.schedule=='m'">{{$t("{price}€/month",{price:price.price})}}</div>
        <div v-else-if="price.schedule=='y'">{{$t("{price}€/year",{price:price.price})}}</div>
      </v-btn>
    </slot>
  </div>
</template>

<script>
import {
  SUPPORTED_LANGS,
  SUPPORTED_SUBMIT_TYPES,
  BILLING_ADDRESS_COLLECTION_TYPES
} from "./constants";
import http from "@/service/http";

import { loadStripeCheckout } from "./load-checkout";
import { publishableKey } from "@/stripe/stripeConfig";

export default {
  name: "StripeCheckout",
  data() {
    return { checkoutId: "" };
  },
  props: {
    coupon: { type: String, default: "" },
    price: { type: Object, default: undefined },
    pk: {
      type: String,
      required: false,
      default: publishableKey
    },
    items: {
      type: Array,
      default: undefined
    },
    successUrl: {
      type: String,
      default: window.location.href
    },
    cancelUrl: {
      type: String,
      default: window.location.href
    },
    submitType: {
      type: String,
      validator: value => SUPPORTED_SUBMIT_TYPES.includes(value)
    },
    billingAddressCollection: {
      type: String,
      default: "auto",
      validator: value => BILLING_ADDRESS_COLLECTION_TYPES.includes(value)
    },
    clientReferenceId: {
      type: String,
      default: undefined
    },
    customerEmail: {
      type: String,
      default: undefined
    },
    sessionId: {
      type: String,
      default: undefined
    },
    locale: {
      type: String,
      default: "auto",
      validator: value => SUPPORTED_LANGS.includes(value)
    }
  },
  watch: {},

  methods: {
    async checkout(priceId) {
      this.$store.state.promiseLoading = true;
      console.log(this.coupon);
      this.$gtag.event("to_checkout", {
        restaurantId: this.$store.getters.restaurant.id,
        coupon: this.coupon
      });
      let urlCreateCheckout = "plans/checkout/" + priceId;
      let response = await http.post(urlCreateCheckout, {
        body: {
          restaurantId: this.$store.getters.restaurant.id,
          coupon: this.coupon
        }
      });
      this.sessionId = response.data.id;
      this.redirectToCheckout();
    },

    redirectToCheckout() {
      this.$emit("loading", true);
      loadStripeCheckout(this.pk, "v3", () => {
        try {
          // console.log("checkout");
          let stripe = window.Stripe(this.pk);
          if (!this.sessionId) {
            stripe.redirectToCheckout({
              billingAddressCollection: this.billingAddressCollection,
              cancelUrl: this.cancelUrl,
              clientReferenceId: this.clientReferenceId,
              customerEmail: this.customerEmail,
              lineItems: this.items,
              locale: this.locale,
              submitType: this.submitType,
              successUrl: this.successUrl,
              mode: "subscription"
            });
          } else {
            stripe.redirectToCheckout({
              sessionId: this.sessionId
            });
          }
        } catch (e) {
          console.error(e);
          this.$emit("error", e);
        } finally {
          this.$emit("loading", false);
        }
      });
    }
  }
};
</script>
